import { Injectable } from '@angular/core';
import {
  AvailableResult,
  BiometryType,
  NativeBiometric,
} from 'capacitor-native-biometric';
import { Preferences } from '@capacitor/preferences';

export type BiometryStatusType = "0" | "1" | "false";

@Injectable({
  providedIn: 'root'
})
export class BiometricsService {

  constructor() { }

  //this sets the value to enabel biometrics by user
  async enableBiometrics(value: BiometryStatusType){
    let prefrencesSet = await Preferences.set({
      key: 'biometric',
      value: value,
    })
    .then(() => true)
    .catch(() => false);

    return prefrencesSet;
  };

  //Check if its enabled by user
  async checkBiometricsStatus(){
    let prefrencesCheck = await Preferences.get({
      key: 'biometric',
    })
    .then((data) => {
      if(data.value != null || data.value != undefined){
        return data.value
      } else { 
        return "0"
      }
    })
    .catch(() => "0");

    return prefrencesCheck;
  };  

  //removes biometric settings
  async removeBiometricsStatus(){
    let prefrencesRemoved = await Preferences.remove({
      key: 'biometric',
    })
    .then(() => true)
    .catch(() => false);

    return prefrencesRemoved;
  }; 

  //  Check if biometrics is available and enabled
  async biometricAvailable() {
    let result:boolean = await NativeBiometric.isAvailable({
      useFallback: true
    })
    .then((data) => data.isAvailable)
    .catch(() => false);
    return result;
  }

  //  Verify the user identity through biometric device, and log in
  async verifyIdentity() {
    let result:any = await NativeBiometric.verifyIdentity({
      reason: 'For easy log in',
      title: 'Log in to our App',
      subtitle: 'Maybe add subtitle here?',
      description: 'Maybe a description too?',
      useFallback: true,
      maxAttempts: 3  // after maxAttempts is reached, fallback is used
    })
    .then(() => true)
    .catch(() => false);

    return result;
  }

  // Retrieve user & pasword from device keychain
  async pullCredentials(server:string) {
    const credentialsFound:any = await NativeBiometric.getCredentials({
      server: server
    })
    return credentialsFound;
  }

  //  Save user's login details to the device's keychain
  async setCredential(userInfo:any) {
    const res:boolean = await NativeBiometric.setCredentials({
      username: userInfo.username,
      password: userInfo.password,
      server: userInfo.server,  // a generated string to identify the credentials object with
    })
    .then(() => true)
    .catch(() => false);

    return res;
  }

  //  remove login details from the device's keychain file.
  async deleteCredential(userInfo:any) {
    // Delete user's credentials
    const res:boolean = await NativeBiometric.deleteCredentials({ server: userInfo.server  })
    .then(() => true)
    .catch(() => false);

    return res;
  }

}
